import { colors } from '../../themes/colors'

export const Gradients: Record<string, string | undefined> = {
  undefined: undefined,
  primary: `linear-gradient(90deg, ${colors.primary400} -1.99%, ${colors.primary500} 50.05%, ${colors.primary700} 104.3%)`,
}
